export function classNames(...classes: any) {
    return classes.filter(Boolean).join(' ')
}

export const naah = (value: any, value2?: any) => {
    let valueToReturn = value2 ?? value;

    if (value) {
        return valueToReturn;
    }

    return "N/A"
}


export function truncateText(text: string, maxLength: number = 44): string {
    if (!text || text.length <= maxLength) {
        return text;
    }

    // Reserve 1 char for ellipsis
    const limit = maxLength - 1;

    // Find last space before cutoff
    let truncated = text.slice(0, limit);
    const lastSpace = truncated.lastIndexOf(" ");

    if (lastSpace > 0) {
        truncated = truncated.slice(0, lastSpace);
    }

    return truncated + "…";
}


